export const catalog = [
  {
    code: "NKFB6448",
    name: "Nike Mesh Back Cap",
    fullname: "Nike Stretch-to-Fit Mesh Back Cap",
    colors: [
      "Anthr White",
      "Blk Blk",
      "Blk Game Royal",
      "Blk White",
      "Cool Grey White",
      "Gym Blue White",
      "Navy White",
      "Team Red White",
      "White White",
    ],
    type: "mens",
    default_color: "Blk Blk",
    sizes: {
      S_M: 30.0,
      M_L: 30.0,
      L_XL: 30.0,
    },
  },
  {
    code: "STC38",
    name: "Sport-Tek Trucker Cap",
    fullname: "Sport-Tek® YP Classics® 5-Panel Trucker Mesh Back Cap",
    colors: [
      "Blk Blk",
      "Blk White",
      "Graphite Graphite",
      "Graphite White",
      "Heather Grey Black",
      "Heather Grey White",
      "Silver Black",
      "True Navy True Navy",
      "True Navy White",
      "True Red White",
      "True Royal White",
      "White Black Black",
      "White True Navy",
    ],
    type: "mens",
    default_color: "Blk Blk",
    sizes: {
      OSFA: 9.0,
    },
  },
  {
    code: "C112",
    name: "Port Authority Trucker Cap",
    fullname: "Port Authority® Snapback Trucker Cap",
    colors: [
      "Black",
      "Black Grey Steel",
      "Black Tan",
      "Black White",
      "Flame Red White",
      "Grey Steel",
      "Gusty Grey",
      "Light Khaki White",
      "Olive Drab Green",
      "Patriot Blue",
      "Patriot Blue White",
      "True Navy",
      "True Pink White",
      "Woodland Camo",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 6.6,
    },
  },
  {
    code: "J317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Core Soft Shell Jacket",
    colors: ["Black", "Battleship Grey"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 44.99,
      Medium: 44.99,
      Large: 44.99,
      XLarge: 44.99,
      "2XLarge": 45.99,
      "3XLarge": 46.99,
      "4XLarge": 47.99,
      "5XLarge": 48.99,
      "6XLarge": 49.99,
    },
  },
  {
    code: "L317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Ladies Core Soft Shell Jacket",
    colors: ["Black", "Battleship Grey"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 44.99,
      Medium: 44.99,
      Large: 44.99,
      XLarge: 44.99,
      "2XLarge": 45.99,
      "3XLarge": 46.99,
      "4XLarge": 47.99,
      "5XLarge": 48.99,
      "6XLarge": 49.99,
    },
  },
  {
    code: "PC55",
    name: "Port & Company Blend Tee",
    fullname: "Port & Company Core Blend Tee",
    colors: ["Charcoal", "Jet Black", "Navy"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 11.99,
      Medium: 11.99,
      Large: 11.99,
      XLarge: 11.99,
      "2XLarge": 13.99,
      "3XLarge": 14.99,
      "4XLarge": 15.99,
      "5XLarge": 16.99,
      "6XLarge": 17.99,
    },
  },
  {
    code: "PC61",
    name: "Port & Company Tee",
    fullname: "Port & Company Essential Tee",
    colors: ["Candy Pink", "Charcoal", "Jet Black", "Medium Grey", "Navy"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 8.99,
      Medium: 8.99,
      Large: 8.99,
      XLarge: 8.99,
      "2XLarge": 10.99,
      "3XLarge": 11.99,
      "4XLarge": 12.99,
      "5XLarge": 13.99,
      "6XLarge": 15.99,
    },
  },
  {
    code: "PC61P",
    name: "Port & Comp Pocket Tee",
    fullname: "Port & Company Essential Pocket Tee",
    colors: ["Charcoal", "Jet Black", "Navy"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 10.99,
      Medium: 10.99,
      Large: 10.99,
      XLarge: 10.99,
      "2XLarge": 12.99,
      "3XLarge": 13.99,
      "4XLarge": 14.99,
    },
  },
  {
    code: "PC380",
    name: "Port & Co Perf Tee",
    fullname: "Port & Company Performance Tee",
    colors: ["Deep Navy"],
    type: "mens",
    sub_category: "tshirt",
    default_color: "Deep Navy",
    sizes: {
      Small: 8.99,
      Medium: 8.99,
      Large: 8.99,
      XLarge: 8.99,
      "2XLarge": 9.99,
      "3XLarge": 10.99,
      "4XLarge": 11.99,
    },
  },
  {
    code: "ST350",
    name: "Sport-Tek PosiCharge Tee",
    fullname: "Sport-Tek PosiCharge Competitor Tee",
    colors: ["Black", "Iron Grey", "True Navy", "Neon Pink"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 12.99,
      Medium: 12.99,
      Large: 12.99,
      XLarge: 12.99,
      "2XLarge": 14.99,
      "3XLarge": 15.99,
      "4XLarge": 16.99,
    },
  },
  {
    code: "ST650",
    name: "Sport-Tek® Polo Shirt",
    fullname: "Sport-Tek® Sport-Wick Polo",
    colors: [
      "Black",
      "True Royal",
      "Iron Grey",
      "Grey Concrete",
      "White",
      "True Navy",
      "Blue Lake",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 24.99,
      Medium: 24.99,
      Large: 24.99,
      XLarge: 24.99,
      "2XLarge": 25.99,
      "3XLarge": 26.99,
      "4XLarge": 27.99,
      "5XLarge": 28.99,
      "6XLarge": 29.99,
    },
  },
  {
    code: "TST650",
    name: "Sport-Tek® TALL Polo Shirt",
    fullname: "Sport-Tek® Tall Sport-Wick Polo",
    colors: [
      "Black",
      "True Royal",
      "Iron Grey",
      "Grey Concrete",
      "White",
      "True Navy",
      "Blue Lake",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      LT: 27.99,
      XLT: 28.99,
      "2XLT": 29.99,
      "3XLT": 31.99,
      "4XLT": 32.99,
    },
  },
  {
    code: "LST650",
    name: "Sport-Tek® Polo Shirt",
    fullname: "Sport-Tek® Sport-Wick Polo",
    colors: [
      "Black",
      "True Royal",
      "Iron Grey",
      "Grey Concrete",
      "White",
      "True Navy",
      "Blue Lake",
    ],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 24.99,
      Medium: 24.99,
      Large: 24.99,
      XLarge: 24.99,
      "2XLarge": 25.99,
      "3XLarge": 26.99,
      "4XLarge": 27.99,
      "5XLarge": 28.99,
      "6XLarge": 29.99,
    },
  },
  // {
  //   code: 'CP80',
  //   name: 'Twill Cap',
  //   fullname: 'Port & Company® Six-Panel Twill Cap',
  //   colors: ['Black', 'True Red', 'Navy', 'Hunter', 'Royal', 'Charcoal', 'Woodland Brown'],
  //   type: 'hat',
  //   default_color: 'Black',
  //   sizes: {
  //     'One Size Fits All': 14.29
  //   }
  // },
  {
    code: "04032",
    name: "20oz. Revolve Tumbler",
    fullname: "20 oz. Revolve Tumbler",
    colors: [
      "Black",
      "Blue",
      "Burgundy",
      "Green",
      "Navy",
      "Red",
      "Silver",
      "White",
    ],
    type: "accessory",
    default_color: "Black",
    sizes: {
      "20 oz.": 14.99,
    },
  },
  {
    code: "04015",
    name: "10oz. Perfect-Fit Tumbler",
    fullname: "10 oz. Perfect-Fit Tumbler",
    colors: ["Black", "Blue", "Burgundy", "Gun Metal", "Navy", "Red"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      "10 oz.": 12.99,
    },
  },
  {
    code: "1640",
    name: "Logo Key Chain",
    fullname: "Brushed Zinc/Leather/Big Logo Key Chain",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      Default: 6.99,
    },
  },
  {
    code: "1240",
    name: "Key Tag",
    fullname: "Zinc Strap Key Tag",
    colors: ["Grey"],
    type: "accessory",
    default_color: "Grey",
    sizes: {
      Default: 6.99,
    },
  },
  {
    code: "2240",
    name: "Key Chain",
    fullname: "Carbon Fiber Strap Metal Key Chain",
    colors: ["Grey"],
    type: "accessory",
    default_color: "Grey",
    sizes: {
      Default: 6.99,
    },
  },
  // {
  //   code: 'C112',
  //   name: 'Snapback',
  //   fullname: 'Port Authority® Snapback Trucker Cap',
  //   colors: ['Black', 'Navy', 'Black White', 'Patriot Royal', 'Red White', 'Royal White', 'Grey Steel', 'Pink White', 'Woodland Camo', 'Khaki White'],
  //   type: 'hat',
  //   halfColors: ['Black White', 'Red White', 'Royal White', 'Pink White', 'Khaki White'],
  //   default_color: 'Black',
  //   sizes: {
  //     'One Size Fits All': 14.29
  //   }
  // },
  {
    code: "NKDC1963",
    name: "Nike® Dri-FIT Polo Shirt",
    fullname: "Nike® Dri-FIT Polo",
    colors: [
      "Gym Blue",
      "Valor Blue",
      "Black",
      "White",
      "Anthracite",
      "University Red",
      "Navy",
      "Blue Tint",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 43.99,
      Medium: 43.99,
      Large: 43.99,
      XLarge: 43.99,
      "2XLarge": 44.99,
      "3XLarge": 45.99,
      "4XLarge": 46.99,
    },
  },
  {
    code: "NKDC1991",
    name: "Nike® Dri-FIT Polo Shirt",
    fullname: "Nike® Dri-FIT Polo",
    colors: [
      "Gym Blue",
      "Valor Blue",
      "Black",
      "White",
      "Anthracite",
      "University Red",
      "Navy",
      "Blue Tint",
    ],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 43.99,
      Medium: 43.99,
      Large: 43.99,
      XLarge: 43.99,
      "2XLarge": 44.99,
      "3XLarge": 45.99,
      "4XLarge": 46.99,
    },
  },
  {
    code: "CGM451",
    name: "Callaway Opti-Vent Polo",
    fullname: "Callaway Opti-Vent Polo",
    colors: ["Peacoat", "Salsa", "White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 44.99,
      Medium: 44.99,
      Large: 44.99,
      XLarge: 44.99,
      "2XLarge": 46.99,
      "3XLarge": 47.99,
      "4XLarge": 48.99,
    },
  },
  {
    code: "J331",
    name: "Port Authority® Rain Jacket",
    fullname: "Port Authority® All-Conditions Jacket",
    colors: ["Black", "Direct Blue"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 75.99,
      Medium: 75.99,
      Large: 75.99,
      XLarge: 75.99,
      "2XLarge": 76.99,
      "3XLarge": 77.99,
      "4XLarge": 78.99,
    },
  },
  {
    code: "L331",
    name: "Port Authority® Rain Jacket",
    fullname: "Port Authority® All-Conditions Jacket",
    colors: ["Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 75.99,
      Medium: 75.99,
      Large: 75.99,
      XLarge: 75.99,
      "2XLarge": 76.99,
      "3XLarge": 77.99,
      "4XLarge": 78.99,
    },
  },
  {
    code: "JST72",
    name: "Sport-Tek® V-Neck Raglan Wind Shirt",
    fullname: "Sport-Tek® Raglan Wind Shirt",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 25.99,
      Medium: 25.99,
      Large: 25.99,
      XLarge: 25.99,
      "2XLarge": 26.99,
      "3XLarge": 27.99,
      "4XLarge": 28.99,
      "5XLarge": 29.99,
      "6XLarge": 30.99,
    },
  },
  {
    code: "CGW437",
    name: "Callaway Opti-Vent Polo",
    fullname: "Callaway Ladies Opti-Vent Polo",
    colors: ["Peacoat", "Salsa", "White"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 44.99,
      Medium: 44.99,
      Large: 44.99,
      XLarge: 44.99,
      "2XLarge": 46.99,
      "3XLarge": 47.99,
      "4XLarge": 48.99,
    },
  },
  {
    code: "K805",
    name: "Port Authority® 1/4-Zip Pullover",
    fullname: "Port Authority® 1/4-Zip Pullover",
    colors: ["Black", "Regatta Blue", "True Navy", "Iron Grey"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 35.99,
      Medium: 35.99,
      Large: 35.99,
      XLarge: 35.99,
      "2XLarge": 36.99,
      "3XLarge": 37.99,
      "4XLarge": 38.99,
    },
  },
  {
    code: "L805",
    name: "Port Authority® 1/4-Zip Pullover",
    fullname: "Port Authority® 1/4-Zip Pullover",
    colors: ["Black", "Regatta Blue", "True Navy", "Iron Grey"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 35.99,
      Medium: 35.99,
      Large: 35.99,
      XLarge: 35.99,
      "2XLarge": 36.99,
      "3XLarge": 37.99,
      "4XLarge": 38.99,
    },
  },
  {
    code: "STIFMO-STKR-462741B",
    name: "Vinyl Sticker w/QR code",
    fullname: "White Vinyl Sticker w/black & reflex blue imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFMO"],
    sizes: {
      2500: 0.59,
      5000: 0.49,      
    },
  },
  {
    code: "STIFMO-31SD-433769B",
    name: "Chrome Stroke Domecal",
    fullname: "Chrome Stroke Domecal w/black & 294 blue imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFMO"],
    sizes: {
      2500: 1.39,
      5000: 1.25,      
    },
  },
  {
    code: "STIFMO-33P-400001Z",
    name: "TAG APPLIED FOR Plate",
    fullname: "TAG APPLIED FOR plate w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFMO"],
    sizes: {
      2500: .87,
      5000: .79,      
    },
  },
  {
    code: "STIFMO-33GT-410883Z",
    name: "Front Plastic Plate",
    fullname: "Plastic Plate w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFMO"],
    sizes: {
      2500: .87,
      5000: .79,      
    },
  },
  {
    code: "STIFSO-THC-509701Z",
    name: "White Domecal",
    fullname: "White Domecal THC w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFSO"],
    sizes: {
      250: 4.67,
      500: 3.99,      
    },
  },
  {
    code: "STIFSO-NOTEPAD-509241Z",
    name: "Notepad - 4in. x 6in.",
    fullname: "Notepad w/full color imprint (25 sheets/pad)",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFSO"],
    sizes: {
      500: 1.46,           
    },
  },
  {
    code: "STIFSO-CLIPBOARD-502574A",
    name: "Letter Clipboard w/imprint",
    fullname: "Round Top Clipboard w/reflex blue imprint (item #CB912RT)",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFSO"],
    sizes: {
      250: 5.98,
      500: 5.79,           
    },
  },
  {
    code: "STIFSO-RULER-502658A",
    name: "12 in. Ruler w/imprint",
    fullname: "Translucent Blue Ruler w/white imprint (item #RUL12)",
    colors: ["Blue"],
    type: "customs",
    default_color: "Blue",
    supportedStores: ["STIFSO"],
    sizes: {
      500: 1.26,                 
    },
  },
  {
    code:"STIFSO-33GT-504866Z",
    name: "Drive Out Plate",
    fullname: "Plastic Drive Out Plate w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIFSO"],
    sizes: {
      2500: .92,
      5000: .85,           
    },
  },
  {
    code:"STICPR-33GT-423219Z",
    name: "Drive Out Plate",
    fullname: "Plastic Drive Out Plate w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STICPR"],
    sizes: {
      2500: .85,
      5000: .79,           
    },
  },
  {
    code:"STICPR-ADD101-441065Z",
    name: "Add Forms",
    fullname: "White Add Forms w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STICPR"],
    sizes: {
       500: .69,
      1000: .59,           
    },
  },
  {
    code: "STICPR-31SD-423222A",
    name: "Chrome Stroke Domecal",
    fullname: "Chrome Stroke Domecal w/black imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STICPR"],
    sizes: {
      2500: 1.09,
      5000: .99,      
    },
  },
  {
    code: "STIHCO-AT4C-436766Z",
    name: "Metal Plates",
    fullname: "White Aluminum Plate w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIHCO"],
    sizes: {
      500: 3.64,
      1000: 3.29,      
    },
  },
  {
    code: "STIHCO-31SD-436768Z",
    name: "White Stroke Domecal",
    fullname: "White Stroke Domecal w/full color imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["STIHCO"],
    sizes: {
      500: 2.75,
      1000: 2.29,      
    },
  },
];
